import { ApolloClient } from '@apollo/client'
import { GetTheatricalReleasesQuery, GetTheatricalReleasesQueryVariables } from '@/types/codegen-federation'
import { logger } from '@/utils/logging'
import { isDefined } from '@/utils/primitives/generics'
import { DeepNonNullable } from '@/utils/types'
import { GET_THEATRICAL_RELEASES } from './queries'

export type GetTheatricalReleasesItem = NonNullable<
  NonNullable<DeepNonNullable<GetTheatricalReleasesQuery, 2>['theatricalReleases']['theatricalRelease']>[number]
>

export async function getCurrentAndUpcomingTheatricalReleases(
  client: ApolloClient<object>,
): Promise<GetTheatricalReleasesItem[]> {
  try {
    const releases = await getAllTheatricalReleases(client)
    const currentAndUpcoming = releases
      .filter(isDefined)
      .filter((release) => release?.region?.ticketsStatus === 'PRE_SALES' || release?.region?.ticketsStatus === 'LIVE')
    return currentAndUpcoming
  } catch (err) {
    logger().error('Error fetching current and upcoming theatrical releases', { error: err })
    return []
  }
}

export async function getAllTheatricalReleases(client: ApolloClient<object>): Promise<GetTheatricalReleasesItem[]> {
  try {
    const result = await client.query<GetTheatricalReleasesQuery, GetTheatricalReleasesQueryVariables>({
      query: GET_THEATRICAL_RELEASES,
      variables: { input: {} },
      errorPolicy: 'all',
    })
    const releases = result.data?.theatricalReleases?.theatricalRelease || []
    return releases.filter(isDefined)
  } catch (err) {
    logger().error('Error fetching all theatrical releases', { error: err })
    return []
  }
}
